import { useMemo } from 'react'

import { cn, formatCountdown } from '@/utils'

import type { Moment } from '@/utils'

type CueElapsedProps = {
  className?: string
  overtimeClassName?: string
  moment?: Moment | null
}

export function CueElapsed({
  className,
  overtimeClassName,
  moment,
}: CueElapsedProps) {
  const overtime = moment && moment.left <= 0

  const Countdown = useMemo(() => {
    if (!moment?.countdown) return null

    return formatCountdown(moment.countdown)
  }, [moment])

  if (!moment?.countdown) {
    return (
      <div className={cn('px-2', className)}>
        <span className="opacity-50">--:--</span>
      </div>
    )
  }

  return (
    <div
      className={cn(
        'px-2',
        overtime ? 'bg-gray-900 rounded-sm text-red-500' : 'text-white',
        overtime && overtimeClassName,
        className,
      )}
    >
      {overtime && '+'}
      {Countdown}
    </div>
  )
}
